import { cn } from "../../lib/utils"

interface SpinnerProps {
  className?: string
  label?: string
}

function Spinner({ className, label = "Loading" }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn(
        "inline-block size-5 animate-spin rounded-full border-2 border-white/10 border-t-brand",
        className
      )}
    />
  )
}

export { Spinner }
